import { repositories } from '../api/createRepositories';

const ttsRepository = repositories.tts;

export const ttsService = {
  textToSpeech: async (voiceId, text, options = {}) => {
    const request = {
      text,
      model_id: options.modelId || 'eleven_multilingual_v2',
      ...options.voiceSettings && { voice_settings: options.voiceSettings }
    };
    return await ttsRepository.textToSpeech(voiceId, request, options);
  },

  streamTextToSpeech: async (voiceId, text, options = {}) => {
    const request = {
      text,
      model_id: options.modelId || 'eleven_multilingual_v2',
      ...options.voiceSettings && { voice_settings: options.voiceSettings }
    };
    return await ttsRepository.streamTextToSpeech(voiceId, request, options);
  }
};

export const {
  textToSpeech,
  streamTextToSpeech
} = ttsService;

export default ttsService;